import { Action } from "..";
import { LasMaterialBase } from "../../types/lasMaterialBase";

export const LAS_MATERIAL_CHANGE = "LAS_MATERIAL_CHANGE";

export function setLasMaterial(lasMaterial: LasMaterialBase): Action {
  return { type: LAS_MATERIAL_CHANGE, payload: lasMaterial };
}
